import hydroLogo from "../assets/images/hydro_logo_vertical_aluminium_rgb.jpg";

function getImage() {
  const img = new Image();
  img.src = hydroLogo;
  return img;
}

export function getAnnotation1(imageSize: number, innerWidth: number) {
  return {
    type: "box",
    backgroundColor: "transparent",
    borderColor: "transparent",
    yMin: 5.5,
    xMax: innerWidth > 500 && innerWidth < 640 ? 2.14 : 2.22,
    label: {
      display: true,
      content: getImage(),
      width: imageSize,
      height: imageSize + 5,
      position: "100%",
    },
  };
}

export function getLabel(innerWidth: number) {
  return {
    type: "label",
    xValue: innerWidth <= 500 ? -0.7 : -0.6,
    yValue: innerWidth <= 550 ? 18 : 20,
    xAdjust: 30,
    yAdjust: innerWidth <= 550 ? 40 : 100,
    rotation: -90,
    backgroundColor: "transparent",
    content: ["kg CO2 pro kg Aluminium"],
    textAlign: "start",
    font: {
      size: innerWidth <= 550 ? 8 : 12,
    },
    callout: {
      display: false,
      side: 10,
    },
  };
}
